import { Box, Button, Stack } from "@mui/material"
import PageElementDTO from "../../DTO/PageElementDTO"
import WidgetUserDTO from "../../DTO/WidgetUserDTO"
import InputB from "../InputB/InputB"
import { Setter } from "../../services/ComService"
import { useEffect, useState } from "react"
import { Plus, Trash } from "react-feather"
import { DisplayPHPDate } from "../../services/DateTime"
import { parseStringFromServer, parseStringToServer } from "../../services/TextConverter"
import { ThumbUp } from "@mui/icons-material"
import mainservice from "../../services/MainService"

export interface IWidgetGroupList {
  widget: WidgetUserDTO,
  pageElement?: PageElementDTO
}

enum Status {
  idle,
  composing,
  sending,
  loading,
  silentLoading,
}

interface ITokenProp {
  id: number,
  key1: string,
  key2: string,
  value1: string,
  value2: string,
  likes?: number,
  ivotedforthis?: boolean,
}

export default function WidgetGroupList({
  widget,
  pageElement
}: IWidgetGroupList) {
  const [newValue, setNewValue] = useState<string>('')
  const [status, setStatus] = useState(Status.idle)
  const [editStatus, setEditStatus] = useState(Status.idle)
  const [entries, setEntries] = useState<ITokenProp[]>([])
  // Mit diesem uuid finde ich global alle Einträge:
  const wuuid = widget.getPropV1({key1: 'globProp', key2: 'uuid'})
  const userId = mainservice.loginService.user.id
  const dateForAll = DisplayPHPDate(new Date('2000-01-01'))
  
  const getEntries = async (silent?: boolean) => {
    if (status === Status.composing) { return }
    setStatus(silent ? Status.silentLoading : Status.loading)
    const result = await Setter('token/getByHash', {
      hash: wuuid,
      start: dateForAll,
    })
    const items = (result.tokenProps || []).map((tP: ITokenProp) => {
      const voteIds = tP.value2.split(',')
      const IVotedForThis = voteIds.includes(String(userId))
      return {
        id: tP.id,
        key1: tP.key1,
        key2: tP.key2,
        value1: parseStringFromServer(tP.value1),
        value2: tP.value2,
        likes: tP.value2 ? tP.value2.split(',').filter(id => id).length : 0,
        ivotedforthis: IVotedForThis
      }
    })
    .sort((a: ITokenProp, b: ITokenProp) => {
      return (b.likes || 0) - (a.likes || 0)  
    })
    setEntries(items)
    setStatus(Status.idle)
  }

  const generateUUID = () => Math.random().toString(36).substring(2, 8);

  useEffect(() => {
    getEntries()
    
    // Set up polling every 15 seconds
    const intervalId = setInterval(() => {
      getEntries(true)
    }, 15000)
    
    // Cleanup interval on unmount
    return () => clearInterval(intervalId)
  }, [])
  
  const sendValue = async (value: string) => {
    setNewValue('')
    setEditStatus(Status.idle)
    setStatus(Status.sending)
    // return
    
    
    const out = {
      kind: 'team',
      hash: wuuid,
      start: dateForAll,
      action: 'addUserValue2',
      tokenProps: [
      {
        key1: `entry-${userId}`,
        key2: generateUUID(),
        value1: parseStringToServer(value),
        value2: ''
      }
      ]
    }
    await Setter('token/setByHash', out)
    await getEntries()
  }

  const voteUp = async (entry: ITokenProp) => {
    setStatus(Status.sending)
    const out = {
      kind: 'team',
      hash: wuuid,
      start: dateForAll,
      action: entry.ivotedforthis ? 'removeUserValue2' : 'addUserValue2',
      tokenProps: [
      {
        key1: entry.key1,
        key2: entry.key2,
        value1: '',
        value2: ''
      }
      ]
    }
    await Setter('token/setByHash', out)
    await getEntries()
  }

  return <Box
    sx={{
      textAlign: "left",
    }}
    >
    <Stack
      direction="column"
      spacing={2}
      sx={{
        justifyContent: "flex-start",
        alignItems: "stretch",
        
      }}
    >
      {
        editStatus === Status.idle &&
        <Button
          onClick={() => {
            setEditStatus(Status.composing)
          }}
        ><Plus /></Button>
      }
      {
        editStatus === Status.composing &&
        <InputB
          returnVal={sendValue}
          sendButton="Eintrag senden"
          value={newValue}
          delay={-1}
        />
      }
      {
        status === Status.loading &&
        <Box>Lade Einträge...</Box>
      }
      {
        entries.map((e, i) => <Box
          key={`wgl-entry-id-${e.id}`}
          sx={{
            borderBottom: '1px solid #ccc',
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
              paddingLeft: 1,
            }}
          >
            <div dangerouslySetInnerHTML={{__html: parseStringFromServer(e.value1)}} />
            <Stack
              direction="row"
              spacing={2}
            >
              {
                e.key1 === `entry-${userId}` &&
                <Button
                  onClick={async () => {
                    setStatus(Status.sending)
                    const out = {
                      kind: 'team',
                      hash: wuuid,
                      start: dateForAll,
                      action: 'removeTokenProp',
                      tokenProps: [
                      {
                        key1: e.key1,
                        key2: e.key2,
                        value1: '',
                        value2: ''
                      }
                      ]
                    }
                    await Setter('token/setByHash', out)
                    await getEntries()
                  }}
                >
                  <Trash />
                </Button>
              }
              <Button
                onClick={() => {
                  voteUp(e)
                }}
                title={e.ivotedforthis ? 'Stimme entfernen' : 'Stimme geben'}
              >
                <ThumbUp
                  sx={{
                    marginRight: 1,
                  }}
                /> {e.likes}
              </Button>
            </Stack>
          </Stack>
        </Box>)
      }  
    </Stack>

  </Box>
}

/**
 * Wie wollen wir die Daten speichern?
 * key1: `entry-${userid}`
 * key2: uuid dieses eintrages - zufällig generiert
 * value1: der Eintrag
 * value2: die IDs der Nutzer, die hierfür gestimmt haben
 * 
 * Aufgaben: Wo finde ich die Unique uuid für genau dieses widget?
 */
